'use client'

import {observer} from 'mobx-react'
import {usePathname, useSearchParams} from 'next/navigation'
import {useRouter} from 'nextjs-toploader/app'
import qs from 'qs'
import {useEffect, useState} from 'react'

import {CatalogProductListContent} from '@/src/core/domain/entities/catalog'

import {useStore} from '@/src/shared/hooks/useStore'
import {Pagination, PaginationOptions} from '@/src/shared/ui/pagination'

import * as UI from './screen.styled'

export const CatalogPaginationContainer = observer(({withoutOptions}: {withoutOptions?: boolean}) => {
  const store = useStore<CatalogProductListContent>()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const router = useRouter()
  const pageData = store.pageData!

  const [limit, setLimit] = useState(pageData.content.products.limit)
  const [page, setPage] = useState(pageData.content.products.page)

  useEffect(() => {
    if (pageData.content.products.page != page) {
      setPage(pageData.content.products.page)
    }
  }, [pageData.content.products.page])

  useEffect(() => {
    if (pageData.content.products.limit != limit) {
      setLimit(pageData.content.products.limit)
    }
  }, [pageData.content.products.limit])

  const onChangePaginationOptions = (perPage: number) => {
    const currentSearchParams = qs.parse(searchParams.toString()) as Record<any, any>
    const queryParams = {...currentSearchParams}

    queryParams.limit = perPage

    const queryParamsText = qs.stringify(queryParams)

    if (queryParamsText === qs.stringify(currentSearchParams)) return
    router.push(`${pathname}${queryParamsText && `?${queryParamsText}`}`)
  }

  const onChangePage = (page: number) => {
    const currentSearchParams = qs.parse(searchParams.toString()) as Record<any, any>
    const queryParams = {...currentSearchParams}

    queryParams.page = page

    const queryParamsText = qs.stringify(queryParams)

    setPage(page)

    if (queryParamsText === qs.stringify(currentSearchParams)) return
    router.push(`${pathname}${queryParamsText && `?${queryParamsText}`}`)
  }

  return (
    <>
      {!withoutOptions && <UI.PaginationOptions as={PaginationOptions} perPage={limit} onChange={onChangePaginationOptions} />}
      <UI.DesktopPagination
        as={Pagination}
        current={page}
        total={pageData.content.products.total}
        pageSize={limit}
        onChange={onChangePage}
      />
    </>
  )
})
